import React from "react";
import { Outlet } from "react-router-dom";
import { Layout, Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Content } = Layout;

const getBasePath = (pathname) => {
  const pathSegments = pathname.split("/");
  if (pathSegments[2] === undefined) {
    return "/";
  } else {
    return `/${pathSegments[2]}`;
  }
};

function MarketingLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const selectedKey = getBasePath(location.pathname);

  const menuItems = [
    {
      key: "/calculator",
      icon: <ArrowLeftOutlined />,
      onClick: () => navigate("/calculator"),
    },
    {
      key: "/affinity-partners",
      label: "Affinity Partners",
      onClick: () => navigate("/marketing/affinity-partners"),
    },
    {
      key: "/discount-reasons",
      label: "Discount Reasons",
      onClick: () => navigate("/marketing/discount-reasons"),
    },
    {
      key: "/subsidies",
      label: "Subsidies",
      onClick: () => navigate("/marketing/subsidies"),
    },
    {
      key: "/matrix",
      label: "Matrix Discounts",
      onClick: () => navigate("/marketing/matrix"),
    },
    {
      key: "/everyday-low",
      label: "Everyday Low Discounts",
      onClick: () => navigate("/marketing/everyday-low"),
    },
    {
      key: "/products",
      label: "Products",
      onClick: () => navigate("/marketing/products"),
    },
    {
      key: "/financing-options",
      label: "Financing Options",
      onClick: () => navigate("/marketing/financing-options"),
    },
    {
      key: "/markups",
      label: "Markups",
      onClick: () => navigate("/marketing/markups"),
    }
  ];

  return (
    <>
      <Layout style={{ height: "100vh" }}>
        <Menu
          mode="horizontal"
          selectedKeys={[selectedKey]}
          items={menuItems}
        />
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </>
  );
}

export default MarketingLayout;